/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const deleteAssessed = /* GraphQL */ `mutation DeleteAssessed($ID: Int!) {
  deleteAssessed(ID: $ID) {
    ID
    AssessmentID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessedMutationVariables,
  APITypes.DeleteAssessedMutation
>;
export const createAssessed = /* GraphQL */ `mutation CreateAssessed($createAssessedInput: CreateAssessedInput!) {
  createAssessed(createAssessedInput: $createAssessedInput) {
    ID
    AssessmentID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessedMutationVariables,
  APITypes.CreateAssessedMutation
>;
export const updateAssessed = /* GraphQL */ `mutation UpdateAssessed($updateAssessedInput: UpdateAssessedInput!) {
  updateAssessed(updateAssessedInput: $updateAssessedInput) {
    ID
    AssessmentID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessedMutationVariables,
  APITypes.UpdateAssessedMutation
>;
export const deleteAssessment = /* GraphQL */ `mutation DeleteAssessment($ID: Int!) {
  deleteAssessment(ID: $ID) {
    ID
    Title
    BranchID
    Assessor
    Created
    TrainingType
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentMutationVariables,
  APITypes.DeleteAssessmentMutation
>;
export const createAssessment = /* GraphQL */ `mutation CreateAssessment($createAssessmentInput: CreateAssessmentInput!) {
  createAssessment(createAssessmentInput: $createAssessmentInput) {
    ID
    Title
    BranchID
    Assessor
    Created
    TrainingType
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentMutationVariables,
  APITypes.CreateAssessmentMutation
>;
export const updateAssessment = /* GraphQL */ `mutation UpdateAssessment($updateAssessmentInput: UpdateAssessmentInput!) {
  updateAssessment(updateAssessmentInput: $updateAssessmentInput) {
    ID
    Title
    BranchID
    Assessor
    Created
    TrainingType
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentMutationVariables,
  APITypes.UpdateAssessmentMutation
>;
export const deleteAssessmentDetail = /* GraphQL */ `mutation DeleteAssessmentDetail($ID: Int!) {
  deleteAssessmentDetail(ID: $ID) {
    ID
    Conditions
    Results
    Reference
    AssessmentID
    IsTemplate
    Location
    Scenario
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentDetailMutationVariables,
  APITypes.DeleteAssessmentDetailMutation
>;
export const createAssessmentDetail = /* GraphQL */ `mutation CreateAssessmentDetail(
  $createAssessmentDetailInput: CreateAssessmentDetailInput!
) {
  createAssessmentDetail(
    createAssessmentDetailInput: $createAssessmentDetailInput
  ) {
    ID
    Conditions
    Results
    Reference
    AssessmentID
    IsTemplate
    Location
    Scenario
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentDetailMutationVariables,
  APITypes.CreateAssessmentDetailMutation
>;
export const updateAssessmentDetail = /* GraphQL */ `mutation UpdateAssessmentDetail(
  $updateAssessmentDetailInput: UpdateAssessmentDetailInput!
) {
  updateAssessmentDetail(
    updateAssessmentDetailInput: $updateAssessmentDetailInput
  ) {
    ID
    Conditions
    Results
    Reference
    AssessmentID
    IsTemplate
    Location
    Scenario
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentDetailMutationVariables,
  APITypes.UpdateAssessmentDetailMutation
>;
export const deleteAssessmentTask = /* GraphQL */ `mutation DeleteAssessmentTask($ID: Int!) {
  deleteAssessmentTask(ID: $ID) {
    ID
    AssessmentID
    TaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentTaskMutationVariables,
  APITypes.DeleteAssessmentTaskMutation
>;
export const createAssessmentTask = /* GraphQL */ `mutation CreateAssessmentTask(
  $createAssessmentTaskInput: CreateAssessmentTaskInput!
) {
  createAssessmentTask(createAssessmentTaskInput: $createAssessmentTaskInput) {
    ID
    AssessmentID
    TaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentTaskMutationVariables,
  APITypes.CreateAssessmentTaskMutation
>;
export const updateAssessmentTask = /* GraphQL */ `mutation UpdateAssessmentTask(
  $updateAssessmentTaskInput: UpdateAssessmentTaskInput!
) {
  updateAssessmentTask(updateAssessmentTaskInput: $updateAssessmentTaskInput) {
    ID
    AssessmentID
    TaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentTaskMutationVariables,
  APITypes.UpdateAssessmentTaskMutation
>;
export const deleteAssessmentTaskPerformanceStep = /* GraphQL */ `mutation DeleteAssessmentTaskPerformanceStep($ID: Int!) {
  deleteAssessmentTaskPerformanceStep(ID: $ID) {
    ID
    ATID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentTaskPerformanceStepMutationVariables,
  APITypes.DeleteAssessmentTaskPerformanceStepMutation
>;
export const createAssessmentTaskPerformanceStep = /* GraphQL */ `mutation CreateAssessmentTaskPerformanceStep(
  $createAssessmentTaskPerformanceStepInput: CreateAssessmentTaskPerformanceStepInput!
) {
  createAssessmentTaskPerformanceStep(
    createAssessmentTaskPerformanceStepInput: $createAssessmentTaskPerformanceStepInput
  ) {
    ID
    ATID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentTaskPerformanceStepMutationVariables,
  APITypes.CreateAssessmentTaskPerformanceStepMutation
>;
export const updateAssessmentTaskPerformanceStep = /* GraphQL */ `mutation UpdateAssessmentTaskPerformanceStep(
  $updateAssessmentTaskPerformanceStepInput: UpdateAssessmentTaskPerformanceStepInput!
) {
  updateAssessmentTaskPerformanceStep(
    updateAssessmentTaskPerformanceStepInput: $updateAssessmentTaskPerformanceStepInput
  ) {
    ID
    ATID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentTaskPerformanceStepMutationVariables,
  APITypes.UpdateAssessmentTaskPerformanceStepMutation
>;
export const deleteAssessmentTaskSubTaskPerformanceStep = /* GraphQL */ `mutation DeleteAssessmentTaskSubTaskPerformanceStep($ID: Int!) {
  deleteAssessmentTaskSubTaskPerformanceStep(ID: $ID) {
    ID
    ATSTID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentTaskSubTaskPerformanceStepMutationVariables,
  APITypes.DeleteAssessmentTaskSubTaskPerformanceStepMutation
>;
export const createAssessmentTaskSubTaskPerformanceStep = /* GraphQL */ `mutation CreateAssessmentTaskSubTaskPerformanceStep(
  $createAssessmentTaskSubTaskPerformanceStepInput: CreateAssessmentTaskSubTaskPerformanceStepInput!
) {
  createAssessmentTaskSubTaskPerformanceStep(
    createAssessmentTaskSubTaskPerformanceStepInput: $createAssessmentTaskSubTaskPerformanceStepInput
  ) {
    ID
    ATSTID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentTaskSubTaskPerformanceStepMutationVariables,
  APITypes.CreateAssessmentTaskSubTaskPerformanceStepMutation
>;
export const updateAssessmentTaskSubTaskPerformanceStep = /* GraphQL */ `mutation UpdateAssessmentTaskSubTaskPerformanceStep(
  $updateAssessmentTaskSubTaskPerformanceStepInput: UpdateAssessmentTaskSubTaskPerformanceStepInput!
) {
  updateAssessmentTaskSubTaskPerformanceStep(
    updateAssessmentTaskSubTaskPerformanceStepInput: $updateAssessmentTaskSubTaskPerformanceStepInput
  ) {
    ID
    ATSTID
    PSID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentTaskSubTaskPerformanceStepMutationVariables,
  APITypes.UpdateAssessmentTaskSubTaskPerformanceStepMutation
>;
export const deleteAssessmentTaskSubTask = /* GraphQL */ `mutation DeleteAssessmentTaskSubTask($ID: Int!) {
  deleteAssessmentTaskSubTask(ID: $ID) {
    ID
    AssessmentTaskID
    SubTaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentTaskSubTaskMutationVariables,
  APITypes.DeleteAssessmentTaskSubTaskMutation
>;
export const createAssessmentTaskSubTask = /* GraphQL */ `mutation CreateAssessmentTaskSubTask(
  $createAssessmentTaskSubTaskInput: CreateAssessmentTaskSubTaskInput!
) {
  createAssessmentTaskSubTask(
    createAssessmentTaskSubTaskInput: $createAssessmentTaskSubTaskInput
  ) {
    ID
    AssessmentTaskID
    SubTaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentTaskSubTaskMutationVariables,
  APITypes.CreateAssessmentTaskSubTaskMutation
>;
export const updateAssessmentTaskSubTask = /* GraphQL */ `mutation UpdateAssessmentTaskSubTask(
  $updateAssessmentTaskSubTaskInput: UpdateAssessmentTaskSubTaskInput!
) {
  updateAssessmentTaskSubTask(
    updateAssessmentTaskSubTaskInput: $updateAssessmentTaskSubTaskInput
  ) {
    ID
    AssessmentTaskID
    SubTaskID
    Rating
    SpecificNeeds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentTaskSubTaskMutationVariables,
  APITypes.UpdateAssessmentTaskSubTaskMutation
>;
export const deleteBranch = /* GraphQL */ `mutation DeleteBranch($ID: Int!) {
  deleteBranch(ID: $ID) {
    ID
    SiteID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBranchMutationVariables,
  APITypes.DeleteBranchMutation
>;
export const createBranch = /* GraphQL */ `mutation CreateBranch($createBranchInput: CreateBranchInput!) {
  createBranch(createBranchInput: $createBranchInput) {
    ID
    SiteID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBranchMutationVariables,
  APITypes.CreateBranchMutation
>;
export const updateBranch = /* GraphQL */ `mutation UpdateBranch($updateBranchInput: UpdateBranchInput!) {
  updateBranch(updateBranchInput: $updateBranchInput) {
    ID
    SiteID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBranchMutationVariables,
  APITypes.UpdateBranchMutation
>;
export const deleteBranchUser = /* GraphQL */ `mutation DeleteBranchUser($UserID: String!, $BranchID: Int!) {
  deleteBranchUser(UserID: $UserID, BranchID: $BranchID) {
    ID
    BranchID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBranchUserMutationVariables,
  APITypes.DeleteBranchUserMutation
>;
export const createBranchUser = /* GraphQL */ `mutation CreateBranchUser($createBranchUserInput: CreateBranchUserInput!) {
  createBranchUser(createBranchUserInput: $createBranchUserInput) {
    ID
    BranchID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBranchUserMutationVariables,
  APITypes.CreateBranchUserMutation
>;
export const updateBranchUser = /* GraphQL */ `mutation UpdateBranchUser($updateBranchUserInput: UpdateBranchUserInput!) {
  updateBranchUser(updateBranchUserInput: $updateBranchUserInput) {
    ID
    BranchID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBranchUserMutationVariables,
  APITypes.UpdateBranchUserMutation
>;
export const deleteSiteUser = /* GraphQL */ `mutation DeleteSiteUser($ID: Int!) {
  deleteSiteUser(ID: $ID) {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSiteUserMutationVariables,
  APITypes.DeleteSiteUserMutation
>;
export const createSiteUser = /* GraphQL */ `mutation CreateSiteUser($createSiteUserInput: CreateSiteUserInput!) {
  createSiteUser(createSiteUserInput: $createSiteUserInput) {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSiteUserMutationVariables,
  APITypes.CreateSiteUserMutation
>;
export const updateSiteUser = /* GraphQL */ `mutation UpdateSiteUser($updateSiteUserInput: UpdateSiteUserInput!) {
  updateSiteUser(updateSiteUserInput: $updateSiteUserInput) {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSiteUserMutationVariables,
  APITypes.UpdateSiteUserMutation
>;
export const deleteSiteAdmin = /* GraphQL */ `mutation DeleteSiteAdmin($ID: Int!) {
  deleteSiteAdmin(ID: $ID) {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSiteAdminMutationVariables,
  APITypes.DeleteSiteAdminMutation
>;
export const createSiteAdmin = /* GraphQL */ `mutation CreateSiteAdmin($createSiteAdminInput: CreateSiteAdminInput!) {
  createSiteAdmin(createSiteAdminInput: $createSiteAdminInput) {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSiteAdminMutationVariables,
  APITypes.CreateSiteAdminMutation
>;
export const updateSiteAdmin = /* GraphQL */ `mutation UpdateSiteAdmin($updateSiteAdminInput: UpdateSiteAdminInput!) {
  updateSiteAdmin(updateSiteAdminInput: $updateSiteAdminInput) {
    ID
    SiteID
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSiteAdminMutationVariables,
  APITypes.UpdateSiteAdminMutation
>;
export const deleteMET = /* GraphQL */ `mutation DeleteMET($ID: Int!) {
  deleteMET(ID: $ID) {
    ID
    Name
    TaskID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMETMutationVariables,
  APITypes.DeleteMETMutation
>;
export const createMET = /* GraphQL */ `mutation CreateMET($createMETInput: CreateMETInput!) {
  createMET(createMETInput: $createMETInput) {
    ID
    Name
    TaskID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMETMutationVariables,
  APITypes.CreateMETMutation
>;
export const updateMET = /* GraphQL */ `mutation UpdateMET($updateMETInput: UpdateMETInput!) {
  updateMET(updateMETInput: $updateMETInput) {
    ID
    Name
    TaskID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMETMutationVariables,
  APITypes.UpdateMETMutation
>;
export const deletePerformanceStep = /* GraphQL */ `mutation DeletePerformanceStep($ID: Int!) {
  deletePerformanceStep(ID: $ID) {
    ID
    Name
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePerformanceStepMutationVariables,
  APITypes.DeletePerformanceStepMutation
>;
export const createPerformanceStep = /* GraphQL */ `mutation CreatePerformanceStep(
  $createPerformanceStepInput: CreatePerformanceStepInput!
) {
  createPerformanceStep(
    createPerformanceStepInput: $createPerformanceStepInput
  ) {
    ID
    Name
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePerformanceStepMutationVariables,
  APITypes.CreatePerformanceStepMutation
>;
export const updatePerformanceStep = /* GraphQL */ `mutation UpdatePerformanceStep(
  $updatePerformanceStepInput: UpdatePerformanceStepInput!
) {
  updatePerformanceStep(
    updatePerformanceStepInput: $updatePerformanceStepInput
  ) {
    ID
    Name
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePerformanceStepMutationVariables,
  APITypes.UpdatePerformanceStepMutation
>;
export const deleteQuarterlyAssessmentDetail = /* GraphQL */ `mutation DeleteQuarterlyAssessmentDetail($ID: Int!) {
  deleteQuarterlyAssessmentDetail(ID: $ID) {
    ID
    StartDate
    EndDate
    AssessmentID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteQuarterlyAssessmentDetailMutationVariables,
  APITypes.DeleteQuarterlyAssessmentDetailMutation
>;
export const createQuarterlyAssessmentDetail = /* GraphQL */ `mutation CreateQuarterlyAssessmentDetail(
  $createQuarterlyAssessmentDetailInput: CreateQuarterlyAssessmentDetailInput!
) {
  createQuarterlyAssessmentDetail(
    createQuarterlyAssessmentDetailInput: $createQuarterlyAssessmentDetailInput
  ) {
    ID
    StartDate
    EndDate
    AssessmentID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateQuarterlyAssessmentDetailMutationVariables,
  APITypes.CreateQuarterlyAssessmentDetailMutation
>;
export const updateQuarterlyAssessmentDetail = /* GraphQL */ `mutation UpdateQuarterlyAssessmentDetail(
  $updateQuarterlyAssessmentDetailInput: UpdateQuarterlyAssessmentDetailInput!
) {
  updateQuarterlyAssessmentDetail(
    updateQuarterlyAssessmentDetailInput: $updateQuarterlyAssessmentDetailInput
  ) {
    ID
    StartDate
    EndDate
    AssessmentID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateQuarterlyAssessmentDetailMutationVariables,
  APITypes.UpdateQuarterlyAssessmentDetailMutation
>;
export const deleteRank = /* GraphQL */ `mutation DeleteRank($ID: String!) {
  deleteRank(ID: $ID) {
    ID
    Value
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRankMutationVariables,
  APITypes.DeleteRankMutation
>;
export const createRank = /* GraphQL */ `mutation CreateRank($createRankInput: CreateRankInput!) {
  createRank(createRankInput: $createRankInput) {
    ID
    Value
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRankMutationVariables,
  APITypes.CreateRankMutation
>;
export const updateRank = /* GraphQL */ `mutation UpdateRank($updateRankInput: UpdateRankInput!) {
  updateRank(updateRankInput: $updateRankInput) {
    ID
    Value
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRankMutationVariables,
  APITypes.UpdateRankMutation
>;
export const deleteSite = /* GraphQL */ `mutation DeleteSite($ID: Int!) {
  deleteSite(ID: $ID) {
    ID
    Name
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSiteMutationVariables,
  APITypes.DeleteSiteMutation
>;
export const createSite = /* GraphQL */ `mutation CreateSite($createSiteInput: CreateSiteInput!) {
  createSite(createSiteInput: $createSiteInput) {
    ID
    Name
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSiteMutationVariables,
  APITypes.CreateSiteMutation
>;
export const updateSite = /* GraphQL */ `mutation UpdateSite($updateSiteInput: UpdateSiteInput!) {
  updateSite(updateSiteInput: $updateSiteInput) {
    ID
    Name
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSiteMutationVariables,
  APITypes.UpdateSiteMutation
>;
export const deleteSubTask = /* GraphQL */ `mutation DeleteSubTask($ID: Int!) {
  deleteSubTask(ID: $ID) {
    ID
    ParentID
    ChildID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubTaskMutationVariables,
  APITypes.DeleteSubTaskMutation
>;
export const createSubTask = /* GraphQL */ `mutation CreateSubTask($createSubTaskInput: CreateSubTaskInput!) {
  createSubTask(createSubTaskInput: $createSubTaskInput) {
    ID
    ParentID
    ChildID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubTaskMutationVariables,
  APITypes.CreateSubTaskMutation
>;
export const updateSubTask = /* GraphQL */ `mutation UpdateSubTask($updateSubTaskInput: UpdateSubTaskInput!) {
  updateSubTask(updateSubTaskInput: $updateSubTaskInput) {
    ID
    ParentID
    ChildID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubTaskMutationVariables,
  APITypes.UpdateSubTaskMutation
>;
export const deleteSubmitToken = /* GraphQL */ `mutation DeleteSubmitToken($ID: Int!) {
  deleteSubmitToken(ID: $ID) {
    ID
    Token
    Time
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSubmitTokenMutationVariables,
  APITypes.DeleteSubmitTokenMutation
>;
export const createSubmitToken = /* GraphQL */ `mutation CreateSubmitToken($createSubmitTokenInput: CreateSubmitTokenInput!) {
  createSubmitToken(createSubmitTokenInput: $createSubmitTokenInput) {
    ID
    Token
    Time
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubmitTokenMutationVariables,
  APITypes.CreateSubmitTokenMutation
>;
export const updateSubmitToken = /* GraphQL */ `mutation UpdateSubmitToken($updateSubmitTokenInput: UpdateSubmitTokenInput!) {
  updateSubmitToken(updateSubmitTokenInput: $updateSubmitTokenInput) {
    ID
    Token
    Time
    UserID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubmitTokenMutationVariables,
  APITypes.UpdateSubmitTokenMutation
>;
export const deleteTask = /* GraphQL */ `mutation DeleteTask($ID: Int!) {
  deleteTask(ID: $ID) {
    ID
    Name
    Number
    Level
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskMutationVariables,
  APITypes.DeleteTaskMutation
>;
export const createTask = /* GraphQL */ `mutation CreateTask($createTaskInput: CreateTaskInput!) {
  createTask(createTaskInput: $createTaskInput) {
    ID
    Name
    Number
    Level
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskMutationVariables,
  APITypes.CreateTaskMutation
>;
export const updateTask = /* GraphQL */ `mutation UpdateTask($updateTaskInput: UpdateTaskInput!) {
  updateTask(updateTaskInput: $updateTaskInput) {
    ID
    Name
    Number
    Level
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskMutationVariables,
  APITypes.UpdateTaskMutation
>;
export const deleteTaskPerformanceStep = /* GraphQL */ `mutation DeleteTaskPerformanceStep($ID: Int!) {
  deleteTaskPerformanceStep(ID: $ID) {
    ID
    TaskID
    PSID
    SequenceNumber
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaskPerformanceStepMutationVariables,
  APITypes.DeleteTaskPerformanceStepMutation
>;
export const createTaskPerformanceStep = /* GraphQL */ `mutation CreateTaskPerformanceStep(
  $createTaskPerformanceStepInput: CreateTaskPerformanceStepInput!
) {
  createTaskPerformanceStep(
    createTaskPerformanceStepInput: $createTaskPerformanceStepInput
  ) {
    ID
    TaskID
    PSID
    SequenceNumber
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaskPerformanceStepMutationVariables,
  APITypes.CreateTaskPerformanceStepMutation
>;
export const updateTaskPerformanceStep = /* GraphQL */ `mutation UpdateTaskPerformanceStep(
  $updateTaskPerformanceStepInput: UpdateTaskPerformanceStepInput!
) {
  updateTaskPerformanceStep(
    updateTaskPerformanceStepInput: $updateTaskPerformanceStepInput
  ) {
    ID
    TaskID
    PSID
    SequenceNumber
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaskPerformanceStepMutationVariables,
  APITypes.UpdateTaskPerformanceStepMutation
>;
export const deleteUnit = /* GraphQL */ `mutation DeleteUnit($ID: Int!) {
  deleteUnit(ID: $ID) {
    ID
    Depth
    Name
    LeaderID
    ParentUnitID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUnitMutationVariables,
  APITypes.DeleteUnitMutation
>;
export const createUnit = /* GraphQL */ `mutation CreateUnit($createUnitInput: CreateUnitInput!) {
  createUnit(createUnitInput: $createUnitInput) {
    ID
    Depth
    Name
    LeaderID
    ParentUnitID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUnitMutationVariables,
  APITypes.CreateUnitMutation
>;
export const updateUnit = /* GraphQL */ `mutation UpdateUnit($updateUnitInput: UpdateUnitInput!) {
  updateUnit(updateUnitInput: $updateUnitInput) {
    ID
    Depth
    Name
    LeaderID
    ParentUnitID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUnitMutationVariables,
  APITypes.UpdateUnitMutation
>;
export const deleteUnitBranch = /* GraphQL */ `mutation DeleteUnitBranch($ID: Int!) {
  deleteUnitBranch(ID: $ID) {
    ID
    UnitID
    BranchID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUnitBranchMutationVariables,
  APITypes.DeleteUnitBranchMutation
>;
export const createUnitBranch = /* GraphQL */ `mutation CreateUnitBranch($createUnitBranchInput: CreateUnitBranchInput!) {
  createUnitBranch(createUnitBranchInput: $createUnitBranchInput) {
    ID
    UnitID
    BranchID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUnitBranchMutationVariables,
  APITypes.CreateUnitBranchMutation
>;
export const updateUnitBranch = /* GraphQL */ `mutation UpdateUnitBranch($updateUnitBranchInput: UpdateUnitBranchInput!) {
  updateUnitBranch(updateUnitBranchInput: $updateUnitBranchInput) {
    ID
    UnitID
    BranchID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUnitBranchMutationVariables,
  APITypes.UpdateUnitBranchMutation
>;
export const deleteUnitTask = /* GraphQL */ `mutation DeleteUnitTask($ID: Int!) {
  deleteUnitTask(ID: $ID) {
    ID
    UnitID
    TaskID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUnitTaskMutationVariables,
  APITypes.DeleteUnitTaskMutation
>;
export const createUnitTask = /* GraphQL */ `mutation CreateUnitTask($createUnitTaskInput: CreateUnitTaskInput!) {
  createUnitTask(createUnitTaskInput: $createUnitTaskInput) {
    ID
    UnitID
    TaskID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUnitTaskMutationVariables,
  APITypes.CreateUnitTaskMutation
>;
export const updateUnitTask = /* GraphQL */ `mutation UpdateUnitTask($updateUnitTaskInput: UpdateUnitTaskInput!) {
  updateUnitTask(updateUnitTaskInput: $updateUnitTaskInput) {
    ID
    UnitID
    TaskID
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUnitTaskMutationVariables,
  APITypes.UpdateUnitTaskMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser($ID: String!) {
  deleteUser(ID: $ID) {
    ID
    Rank
    Name
    Email
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser($createUserInput: CreateUserInput!) {
  createUser(createUserInput: $createUserInput) {
    ID
    Rank
    Name
    Email
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    ID
    Rank
    Name
    Email
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
